import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const Details = ({ popUpOpen, togglePopUp, details }) => {
  const handleCancel = () => {
    togglePopUp();
  };

  const shouldExcludeKey = (key) => {
    const lowerKey = key.toLowerCase();
    return (
      lowerKey === 'condition' ||
      lowerKey === '__v' ||
      lowerKey === 'users_oid' ||
      lowerKey === 'update_by' ||
      lowerKey === 'createdAt' ||
      lowerKey === 'updatedAt' ||
      lowerKey === 'debit_user' ||
      lowerKey === 'credit_user' ||
      lowerKey === 'created_by' ||
      lowerKey === 'created_by_users_id' ||
      lowerKey === '_id'
    );
  };

  const renderTable = (data) => {
    if (Array.isArray(data)) {
      if (data.length === 0) return <div>No details available</div>;
      // If array of objects, use keys from first object, excluding 'condition' and object id variants
      const keys = Object.keys(data[0] || {}).filter((key) => !shouldExcludeKey(key));
      return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {keys.map((key) => (
                <th key={key} style={{ border: '1px solid #ccc', padding: '4px', background: '#f5f5f5' }}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                {keys.map((key) => (
                  <td key={key} style={{ border: '1px solid #ccc', padding: '4px' }}>{
                    typeof row[key] === 'object' && row[key] !== null
                      ? JSON.stringify(row[key])
                      : String(row[key])
                  }</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else if (typeof data === 'object' && data !== null) {
      // Exclude 'condition' and object id variants
      const keys = Object.keys(data).filter((key) => !shouldExcludeKey(key));
      return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {keys.map((key) => (
              <tr key={key}>
                <th style={{ border: '1px solid #ccc', padding: '4px', background: '#f5f5f5', textAlign: 'left', width: '30%' }}>{key}</th>
                <td style={{ border: '1px solid #ccc', padding: '4px' }}>{
                  typeof data[key] === 'object' && data[key] !== null
                    ? JSON.stringify(data[key], null, 2)
                    : String(data[key])
                }</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    return null;
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={togglePopUp}
      maxWidth="xl"
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151", fontSize : '2rem' }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <h5 style={{textAlign : 'center'}}>Details</h5>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
          style={{textAlign : 'left'}}
        >
          <h5>
            {typeof details === "string" ? (
              details
            ) : Array.isArray(details) || (typeof details === "object" && details !== null) ? (
              renderTable(details)
            ) : (
              "No details available"
            )}
          </h5>
        </Typography>
      </div>
    </Dialog>
  );
};

export default Details;
